
import { configureStore } from '@reduxjs/toolkit';
import tasksReducer from './features/tasks/tasksSlice';
import classesReducer from './features/classes/classesSlice';

const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('tasks', JSON.stringify(state.tasks));
    localStorage.setItem('classes', JSON.stringify(state.classes));
  } catch (e) {
    console.warn('Error saving to localStorage', e);
  }
};

const loadFromLocalStorage = () => {
  try {
    const tasks = localStorage.getItem('tasks');
    const classes = localStorage.getItem('classes');
    return {
      tasks: tasks ? JSON.parse(tasks) : [],
      classes: classes
        ? JSON.parse(classes)
        : {
            subjects: [],
            timetable: {
              Monday: {},
              Tuesday: {},
              Wednesday: {},
              Thursday: {},
              Friday: {}
            },
            timetableView: 'table'
          }
    };
  } catch (e) {
    console.warn('Error loading from localStorage', e);
    return {
      tasks: [],
      classes: {
        subjects: [],
        timetable: {
          Monday: {},
          Tuesday: {},
          Wednesday: {},
          Thursday: {},
          Friday: {}
        },
        timetableView: 'table'
      }
    };
  }
};

const preloadedState = loadFromLocalStorage();

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    classes: classesReducer
  },
  preloadedState
});

store.subscribe(() => {
  saveToLocalStorage(store.getState());
});
